Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Gist", {
  enumerable: true,
  get: function get() {
    return _gist.Gist;
  }
});
var _gist = require("./gist");